export const ECsArray = [
  //{ Name: "IP_id", Field: "IP_id" },
  { Name: "First Name", Field: "First_Name" },
  { Name: "Last Name", Field: "Last_Name" },
  { Name: "Email", Field: "Email" },
  { Name: "Number", Field: "Number" },
  { Name: "Commision %", Field: "Commision" },
];
